import { useCallback, useMemo } from 'react';

import formStore from '@/modules/offer/stores/form'
import { useDefaultEvents, useGrid } from '@Components/Grid';

export default function useEvents() {
  const { handleDeleteEntry, handleUpdateEntry } = useDefaultEvents()
  const { store: { collection: { save } }, handleRefresh } = useGrid()

  const handleDuplicateEntry = useCallback(async row => {
    const { data: forms } = await formStore.all()
    const slugs = new Set(forms.map(form => form.slug))

    let slug = `${row.slug}-copy`
    for (let copy = 2; slugs.has(slug); copy++) {
      slug = `${row.slug}-copy-${copy}`
    }

    await save({ ...row, id: null, slug })
    await handleRefresh()
  }, [save, handleRefresh])

  return useMemo(() => ({
    handleUpdateEntry,
    handleDeleteEntry,
    handleDuplicateEntry,
  }), [handleUpdateEntry, handleDeleteEntry, handleDuplicateEntry])
}
